import { useEffect } from 'react';
import { SidebarFooter } from './SidebarFooter.js';
import { type NavItem, SidebarNav } from './SidebarNav.js';

interface MobileNavDrawerProps {
  open: boolean;
  onClose: () => void;
  navItems: NavItem[];
}

export function MobileNavDrawer({ open, onClose, navItems }: MobileNavDrawerProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: #950 a mouse-only convenience; the keyboard closes this with Escape (document keydown handler above) */}
      <div
        data-testid="drawer-backdrop"
        className="fixed inset-0 bg-black/40"
        aria-hidden="true"
        onClick={onClose}
      />
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: #950 delegated close on a link click; the links themselves are keyboard-operable */}
      <div
        className="relative flex h-full w-64 flex-col rounded-r-xl bg-canvas p-2 shadow-xl"
        // biome-ignore lint/a11y/useSemanticElements: #950 role="dialog" on a positioned panel is the intended ARIA pattern; native <dialog> is hidden until opened and brings its own positioning
        role="dialog"
        aria-modal="true"
        aria-label="Navigation"
        onClick={(e) => {
          if ((e.target as HTMLElement).closest('a')) onClose();
        }}
      >
        <div className="flex-1 overflow-y-auto">
          <SidebarNav items={navItems} />
        </div>
        <SidebarFooter />
      </div>
    </div>
  );
}
